module.exports = __webpack_public_path__ + "static/media/OpenNowicon.d0534562.svg";